import { forwardRef } from 'react';
import type { JavascriptHookCustomAction } from 'autogen/swagger/all';
import type { CustomActionProps } from '../shared/types';
import CustomerServiceAction from './JavascriptHookActions/CustomerServiceAction';
import RevieveAction from './JavascriptHookActions/RevieveAction';

type CustomerServiceActionProps = { action: JavascriptHookCustomAction } & CustomActionProps;

const JavascriptHookActionRenderer = forwardRef<HTMLButtonElement, CustomerServiceActionProps>(
    ({ action, onClick, ...restProps }, ref) => {
        const { javascriptHookType } = action;

        switch (javascriptHookType) {
            case 'MakeupAdvisor':
            case 'InStoreMakeupAdvisor':
            case 'SkinAnalytics':
            case 'InStoreSkinAnalytics':
                return (
                    <RevieveAction
                        action={{ ...action, javascriptHookType }} // TS doesn't understand that action.javascriptHookType has been narrowed down by the switch case.
                        onClick={onClick}
                        ref={ref}
                        {...restProps}
                    />
                );
            case 'OpenCustomerServiceChat':
                return (
                    <CustomerServiceAction
                        action={{ ...action, javascriptHookType }} // 1TS doesn't understand that action.javascriptHookType has been narrowed down by the switch case.
                        onClick={onClick}
                        ref={ref}
                        className="open-chat"
                        {...restProps}
                    />
                );
            default:
                return null;
        }
    }
);

export default JavascriptHookActionRenderer;
